import { Injectable } from '@angular/core';
import { Material } from '../shoppingcart/material';
import { Item } from './item';
import { DataLayer } from './datalayer';
import { Package } from './package';
import { CookieObject } from '../cookie/cookieobject';
import { CustomDatalayerObject } from './customdatalayerobject';
import { LinkObject } from './linkObject';

declare global {
    interface Window {
        dataLayer: any[];
    }
}

@Injectable({
    providedIn: 'root'
})

//TODO by increase/decrease quantity of product do something!!! What is difference between select_item and view_item?We also have add_to_cart...
//TODO begin_checkout, refund!!!

//TODO removeItem-el foglalkozni window.reload() miatt cartsumon és shopping cart on
export class GoogleTagManagerService {
    dataLayer = window.dataLayer || [];

    dataLayerObject?: DataLayer = {};

    customDataLayerObject?: CustomDatalayerObject = {};

    linkObject?: LinkObject = {};

    item?: Item = {};

    itemList: Item[] = [];

    WEBSHOP_NAME = 'Multiverzum Kiadó Webshop';

    ITEM_BRAND = 'Multiverzum';

    ITEM_LIST_ID = 'books';
    ITEM_LIST_NAME = 'Könyvek';
    ITEM_LIST_PACKAGE_ID = 'package';
    ITEM_LIST_PACKAGE_NAME = 'Könyvcsomag';

    ITEM_VARIANT = 'könyv';

    ITEM_VARIANT_PACKAGE = 'könyvcsomag';

    VIEW_ITEM_LIST = 'view_item_list';

    SELECT_ITEM = 'select_item';

    ADD_TO_CART = 'add_to_cart';

    VIEW_ITEM = 'view_item';

    VIEW_CART = 'view_cart';

    REMOVE_FROM_CART = 'remove_from_cart';

    BEGIN_CHECKOUT = 'begin-checkout';

    ADD_SHIPPING_INFO = 'add_shipping_info';

    ADD_PAYMENT_INFO = 'add_payment_info';

    PURCHASE = 'purchase';

    //TODO making REFUND method and push it into dataLayer
    REFUND = 'refund';

    DELIVERY_FEE = 1140;

    currency = 'HUF';

    COOKIE_CONSENT_KEY = 'cookie_consent';

    viewCustomObject(event: string, name: string) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push(this.buildCustomObject(event, name));
        }
    }

    viewProductItemList(materials: Material[]) {
        // Clear the previous ecommerce object.
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectList(materials, this.VIEW_ITEM_LIST));
        }
    }

    viewPackageItemList(packageList: Package[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommercePackageList(packageList, this.VIEW_ITEM_LIST));
        }
    }

    selectProductItem(material: Material) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObject(material, this.SELECT_ITEM));
        }
    }

    selectPackageItem(packageElement: Package, materials: Material[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectListForPackage(materials, packageElement, this.SELECT_ITEM));
        }
    }

    viewProductItem(material: Material) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObject(material, this.VIEW_ITEM));
        }
    }

    viewPackageItem(materials: Material[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectList(materials, this.VIEW_ITEM));
        }
    }

    addtoCartProduct(material: Material) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObject(material, this.ADD_TO_CART));
        }
    }

    addtoCartPackage(materials: Material[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectList(materials, this.ADD_TO_CART));
        }
    }

    //TODO if we have has to be added
    addToWishList() {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
        }
    }

    viewCart(materials: Material[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectList(materials, this.VIEW_CART));
        }

    }

    removeProductFromCart(material: Material) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObject(material, this.REMOVE_FROM_CART));
        }
    }

    removePackageFromCart(materials: Material[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectList(materials, this.REMOVE_FROM_CART));
        }
    }

    beginCheckOut(materials: Material[]) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectList(materials, this.BEGIN_CHECKOUT));
        }
    }

    //shipping-tier means delivery option
    addShippingInfo(materials: Material[], shippingTier: string) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectListToShippingInfo(materials, this.ADD_SHIPPING_INFO, shippingTier));
        }
    }

    addPaymentInfo(materials: Material[], paymentType: string) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push({ ecommerce: null });
            this.dataLayer.push(this.buildEcommerceObjectListToPaymentInfo(materials, this.ADD_SHIPPING_INFO, paymentType));
        }
    }

    purchase(materialList: Material[], totalPrice: number, shippingTier: string, tax: number, orderReference: string) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.dataLayer.push(
                this.buildEcommerceObjectListPurchase(materialList, this.PURCHASE, totalPrice, shippingTier, tax, orderReference)
            );
        }
    }

    refund() { }

    buildEcommerceObject(material: Material, event: string): DataLayer {
        this.dataLayerObject = {
            event: event,
            ecommerce: {
                currency: this.currency,
                value: material.originalPrice,
                itemListId: this.ITEM_LIST_ID,
                itemListName: this.ITEM_LIST_NAME,
                items: [
                    {
                        item_id: String(material.id),
                        item_name: material.author + ': ' + material.title,
                        affiliation: this.WEBSHOP_NAME,
                        coupon: '',
                        discount: 0,
                        index: material.id,
                        item_brand: this.ITEM_BRAND,
                        item_category: '',
                        item_category2: '',
                        item_category3: '',
                        item_category4: '',
                        item_category5: '',
                        item_list_id: this.ITEM_LIST_ID,
                        item_list_name: this.ITEM_LIST_NAME,
                        item_variant: this.ITEM_VARIANT,
                        location_id: '',
                        price: material.originalPrice,
                        quantity: material.quantity
                    }
                ]
            }
        };
        return this.dataLayerObject;
    }

    buildEcommerceObjectList(materialList: Material[], event: string): DataLayer {
        this.buildingItemList(materialList);
        this.dataLayerObject = {
            event: event,
            ecommerce: {
                value: this.calculateMaterialTotalPrice(materialList),
                currency: this.currency,
                itemListId: this.ITEM_LIST_ID,
                itemListName: this.ITEM_LIST_NAME,
                items: this.buildingItemList(materialList)
            }
        };
        return this.dataLayerObject;
    }

    buildingItemList(materialList: Material[]): Item[] {
        const itemList: Item[] = [];
        materialList.forEach((material) => {
            this.item = {
                item_id: String(material.id),
                item_name: material.author + ': ' + material.title,
                affiliation: this.WEBSHOP_NAME,
                coupon: '',
                discount: 0,
                index: material.id,
                item_brand: this.ITEM_BRAND,
                item_category: '',
                item_category2: '',
                item_category3: '',
                item_category4: '',
                item_category5: '',
                item_list_id: this.ITEM_LIST_ID,
                item_list_name: this.ITEM_LIST_NAME,
                item_variant: this.ITEM_VARIANT,
                location_id: '',
                price: material.originalPrice,
                quantity: material.quantity
            };
            itemList?.push(this.item);
        });
        return itemList;
    }

    buildEcommerceObjectListToShippingInfo(materialList: Material[], event: string, shippingTier: string): DataLayer {
        this.buildingItemList(materialList);

        this.dataLayerObject = {
            event: event,
            ecommerce: {
                value: this.calculateMaterialTotalPrice(materialList),
                currency: this.currency,
                itemListId: this.ITEM_LIST_ID,
                itemListName: this.ITEM_LIST_NAME,
                shipping_tier: shippingTier,
                items: this.buildingItemList(materialList)
            }
        };
        return this.dataLayerObject;
    }

    buildEcommerceObjectListToPaymentInfo(materialList: Material[], event: string, paymentType: string): DataLayer {
        this.buildingItemList(materialList);

        this.dataLayerObject = {
            event: event,
            ecommerce: {
                value: this.calculateMaterialTotalPrice(materialList),
                currency: this.currency,
                itemListId: this.ITEM_LIST_ID,
                itemListName: this.ITEM_LIST_NAME,
                payment_type: paymentType,
                items: this.buildingItemList(materialList)
            }
        };
        return this.dataLayerObject;
    }

    buildEcommerceObjectListTotalPrice(materialList: Material[], event: string, totalPrice: number): DataLayer {
        this.buildingItemList(materialList);

        this.dataLayerObject = {
            event: event,
            ecommerce: {
                currency: this.currency,
                itemListId: this.ITEM_LIST_ID,
                itemListName: this.ITEM_LIST_NAME,
                value: totalPrice,
                items: this.buildingItemList(materialList)
            }
        };
        return this.dataLayerObject;
    }

    buildEcommerceObjectListPurchase(
        materialList: Material[],
        event: string,
        totalPrice: number,
        shippingTier: string,
        tax: number,
        orderReference: string
    ): DataLayer {
        let shippingCost = 0;
        if (shippingTier === 'FOXPOST' || 'PACKETA') {
            shippingCost = this.DELIVERY_FEE;
        } else if (shippingTier === 'STORE_PICKUP') {
            shippingCost = 0;
        }
        this.buildingItemList(materialList);

        this.dataLayerObject = {
            event: event,
            ecommerce: {
                transaction_id: orderReference,
                tax: tax,
                shipping: shippingCost,
                currency: this.currency,
                value: totalPrice,
                items: this.buildingItemList(materialList)
            }
        };
        return this.dataLayerObject;
    }

    buildEcommercePackageList(packageList: Package[], event: string): DataLayer {
        this.dataLayerObject = {
            event: event,
            ecommerce: {
                itemListId: this.ITEM_LIST_ID,
                itemListName: this.ITEM_LIST_PACKAGE_NAME,
                items: this.buildingPackageItemList(packageList)
            }
        };
        return this.dataLayerObject;
    }

    buildingPackageItemList(packageList: Package[]): Item[] {
        const itemList: Item[] = [];

        packageList.forEach((packageElement) => {
            this.item = {
                item_id: String(packageElement.id),
                item_name: packageElement.packageName,
                affiliation: this.WEBSHOP_NAME,
                coupon: '',
                discount: 0,
                index: packageElement.id,
                item_brand: this.ITEM_BRAND,
                item_category: '',
                item_category2: '',
                item_category3: '',
                item_category4: '',
                item_category5: '',
                item_list_id: this.ITEM_LIST_ID,
                item_list_name: this.ITEM_LIST_NAME,
                item_variant: this.ITEM_VARIANT_PACKAGE,
                location_id: '',
                price: packageElement.packagePrice,
                quantity: 0
            };
            itemList?.push(this.item);
        });
        return itemList;
    }

    buildEcommerceObjectListForPackage(materials: Material[], packageElement: Package, event: string): any {

        this.dataLayerObject = {
            event: event,
            ecommerce: {
                value: this.calculateMaterialTotalPrice(materials),
                currency: this.currency,
                itemListId: this.ITEM_LIST_PACKAGE_ID,
                itemListName: packageElement.packageName,
                items: this.buildingItemList(materials)
            }
        };
        return this.dataLayerObject;
    }

    buildCustomObject(eventName: string, name: string) {
        this.customDataLayerObject = {
            event: eventName,
            customObject: {
                name: name
            }
        };
        return this.customDataLayerObject;

    }

    calculateMaterialTotalPrice(materials: Material[]) {
        let materialTotalPrice = 0;
        materials.forEach((material) => {
            materialTotalPrice += material.packagePrice!;
        });
        return materialTotalPrice;
    }

    pushLinkIntoDataLayer(event: string, linkUrl: string) {
        if (this.isGoogleAnalyticsCookieAccepted()) {
            this.linkObject = {
                event: event,
                linkUrl: linkUrl
            }
            this.dataLayer.push(this.linkObject);
        }
    }


    isGoogleAnalyticsCookieAccepted(): boolean {

        if (localStorage.getItem(this.COOKIE_CONSENT_KEY)) {
            const cookie: CookieObject = JSON.parse(localStorage.getItem(this.COOKIE_CONSENT_KEY) as string) as CookieObject;

            if (cookie.googleAnalyticsGtagVariable === 'granted') {
                return true;
            }
            return false;
        }
        return false;
    }
}
